

import { ArrowBack, Instagram, Mail, YouTube } from "@mui/icons-material";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AllInfluencerDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const influencer = location.state?.influencer;

  useEffect(() => {
    if (influencer) {
      console.log("Influencer Details:", influencer);
    }
  }, [influencer]);

  const handleBackClick = () => {
    navigate(-1);
  };

  if (!influencer) {
    return <div className="p-4">No influencer data available.</div>;
  }

  return (
    <div className="flex flex-col min-h-screen bg-white pt-20 px-4 pb-20">
      {/* Header */}
      <div className="bg-gray-100 text-black flex items-center p-4 fixed top-0 left-0 right-0 z-10 shadow-md">
        <ArrowBack
          onClick={handleBackClick}
          className="cursor-pointer mr-4"
          fontSize="large"
        />
        <h1 className="text-xl font-semibold">Influencer Details</h1>
      </div>

      {/* Profile Row */}
      <div className="flex items-center space-x-4 mt-6 mb-12">
        <img
          src="https://res.cloudinary.com/dwy9jfjpq/image/upload/v1739715011/manager_profile_pics/xru8bht53ml5f5rvui9y.jpg"
          alt="Influencer"
          className="w-16 h-16 object-cover rounded-full border-2 border-violet-600"
        />
        <div>
          <span className="text-violet-600 font-semibold block">Influencer</span>
          <h1 className="text-2xl font-bold">
            {influencer?.name || "Influencer Name"}
          </h1>
        </div>
      </div>

      {/* Details Section */}
      <div className="mt-8 space-y-4 text-gray-800">
        <div>
          <span className="font-semibold">Category:</span>{" "}
          {influencer?.category || "No category"}
        </div>
        <div>
          <span className="font-semibold">Location:</span>{" "}
          {influencer?.location || "No location"}
        </div>
        <div>
          <span className="font-semibold">Commercial:</span>{" "}
          {influencer?.commercial || "No commercial"}
        </div>
        <div>
          <span className="font-semibold">Followers:</span>{" "}
          {influencer?.followers || "No followers"}
        </div>
        <div>
          <span className="font-semibold">Contact:</span>{" "}
          {influencer?.contactNumber || "No contact number"}
        </div>
        <div>
          <span className="font-semibold">Email:</span>{" "}
          {influencer?.email || "No email"}
        </div>
      </div>

      {/* Social Media Links */}
      <div className="mt-10">
        <h4 className="text-lg font-semibold mb-4">Social Media Links</h4>
        <div className="flex space-x-8 text-3xl">
          {influencer?.instagramProfile && (
            <a
              href={influencer.instagramProfile}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800"
            >
              <Instagram fontSize="inherit" />
            </a>
          )}
          {influencer?.youtubeLink && (
            <a
              href={influencer.youtubeLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-600 hover:text-red-800"
            >
              <YouTube fontSize="inherit" />
            </a>
          )}
          {influencer?.email && (
            <a
              href={`mailto:${influencer.email}`}
              className="text-gray-600 hover:text-gray-800"
            >
              <Mail fontSize="inherit" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllInfluencerDetails;
